const SITE_URL = "https://elikya.tech";
const DEFAULT_OG = "Elikya Technology — Powering Modern Payments, Unlocking Growth Everywhere";

// Brand + core keywords included on every route.
const BRAND_KEYWORDS =
  "elikya, technology, fintech, africa, payments, elikya technology, elikya tech";

// Full site-wide keyword set (used as the default when a page doesn't pass its own).
export const SITE_KEYWORDS = [
  BRAND_KEYWORDS,
  "payments south africa, payments congo, payments drc, payments dr congo, kinshasa payment gateway, democratic republic of congo fintech, sub-saharan africa payment solutions, pan-african payment infrastructure, cross-border payments africa, delaware incorporated fintech africa",
  "merchant payment gateway africa, accept mobile money online, omnichannel payment platform africa, b2b payment solutions africa, enterprise payment infrastructure, multi-currency settlement africa, automated business billing platform, pci dss compliant payment provider africa, mobile money integration hub, ussd payment gateway, financial ledger engine, double-entry balance engine, high-availability payment rails, card processing hub africa",
  "girdercore, girdercore ledger engine, girdercore platform, girdercore payment architecture, girdercore financial engine, double-entry ledger core, transaction reconciliation engine, high-throughput balance ledger, core banking ledger integration",
  "zando, zando commerce, ecommerce, ecommerce africa, african ecommerce platform, online shopping africa, digital commerce hub, merchant marketplace africa, online checkout system, digital storefront infrastructure, cart and checkout integration, retail tech africa",
].join(", ");

export const Seo = ({
  title,
  description,
  keywords,
  path = "/",
  robots = "index, follow",
  ogType = "website",
  ogImage: ogImageProp,
  jsonLd,
}) => {
  const fullTitle = title ? `${title} | Elikya Technology` : "Elikya Technology | Modern Payment Solutions";
  const canonical = `${SITE_URL}${path}`;
  const ogImage = ogImageProp ? `${SITE_URL}${ogImageProp}` : `${SITE_URL}/og-image.png`;
  const metaKeywords = keywords || SITE_KEYWORDS;
  const schemas = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={metaKeywords} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:site_name" content="Elikya Technology" />
      <meta property="og:title" content={title || DEFAULT_OG} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Elikya — powering modern payments, unlocking growth everywhere" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || DEFAULT_OG} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:site" content="@elikya" />

      {schemas.map((schema, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
};

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Elikya Technology",
  legalName: "Elikya Technology, Inc.",
  url: SITE_URL,
  logo: `${SITE_URL}/icon-512.png`,
  description:
    "Elikya Technology builds secure, reliable payment solutions that help businesses accept money, automate billing and scale across emerging and global markets.",
  foundingDate: "2023",
  email: "hello@elikya.tech",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Newark",
    addressLocality: "Newark",
    addressRegion: "Delaware",
    addressCountry: "US",
  },
  areaServed: [
    { "@type": "Country", name: "South Africa" },
    { "@type": "Country", name: "Democratic Republic of the Congo" },
  ],
  contactPoint: [
    {
      "@type": "ContactPoint",
      email: "hello@elikya.tech",
      contactType: "customer support",
      availableLanguage: ["English", "French"],
    },
  ],
};

export { SITE_URL };
